(function () {
  // Remove the view transition render blocker if the user has reduced motion enabled.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
    if (viewTransitionRenderBlocker) viewTransitionRenderBlocker.remove();
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  /**
   * LUCID LOOM — STEP 96
   * Horizon opts the document into cross-document View Transitions via base.css,
   * while the actual "page transitions" theme setting is carried on <main>.
   * When that setting is false, do not create/maintain the generic
   * `page-navigation` transition type. Product-card -> PDP transitions remain
   * intact because they use their explicit custom transition type.
   */
  function pageTransitionsEnabled() {
    return document.querySelector('main[data-page-transition-enabled="true"]') !== null;
  }

  /**
   * @param {PageSwapEvent} event
   */
  window.addEventListener('pageswap', async (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          viewTransition.skipTransition();
        },
        { once: true }
      );
    });

    // Clean in case you landed on the PDP first. We want to remove the default
    // transition type on the PDP media gallery so there is no duplicate name.
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      // Explicit product-card -> PDP transition: preserve existing behavior.
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      sessionStorage.setItem('custom-transition-type', transitionType);
      return;
    }

    sessionStorage.removeItem('custom-transition-type');

    if (pageTransitionsEnabled()) {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      return;
    }

    // Generic page transitions are disabled in Theme settings. Do not make the
    // browser perform the root/page-navigation transition work anyway.
    viewTransition.skipTransition();
  });

  /**
   * @param {PageRevealEvent} event
   */
  window.addEventListener('pagereveal', async (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;
    const customTransitionType = sessionStorage.getItem('custom-transition-type');

    if (customTransitionType) {
      // Incoming half of an explicit product-card -> PDP transition.
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      if (pageTransitionsEnabled()) {
        viewTransition.types.add('page-navigation');
      }

      idleCallback(() => {
        sessionStorage.removeItem('custom-transition-type');
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
      return;
    }

    if (pageTransitionsEnabled()) {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      return;
    }

    // No custom product transition and generic page transitions are disabled.
    // Skip immediately instead of activating the expensive root transition type.
    viewTransition.skipTransition();
  });

  /**
   * Checks whether an Event object is carrying a `viewTransition` property
   * (as used by the View Transition API) and narrows the type accordingly.
   *
   * @template {Event} T
   * @param {T} event
   * @returns {event is T & { viewTransition: ViewTransition }}
   */
  function hasViewTransition(event) {
    return 'viewTransition' in event && event.viewTransition instanceof ViewTransition;
  }
})();
